import {
  Rarity,
  SeasonEligibility,
  Sport,
} from '@sorare/core/src/__generated__/globalTypes';
import { LIFECYCLE, useLifecycle } from '@sorare/core/src/hooks/useLifecycle';
import { StatsRarity } from '@sorare/core/src/lib/playerSearchView';

import { SeasonEligibilityOptions } from 'lib/seasonalities';

export const usePlayerPageFilters = (sport: Sport) => {
  const { lifecycle, update: updateLifecycle } = useLifecycle();
  const playerPageFilters = lifecycle?.[LIFECYCLE.playerPageFilters]?.[
    sport
  ] || {
    rarity: Rarity.limited,
    seasonality: SeasonEligibility.IN_SEASON,
  };

  const setFilters = (filters: {
    rarity: StatsRarity;
    seasonality: SeasonEligibilityOptions;
  }) => {
    updateLifecycle(LIFECYCLE.playerPageFilters, {
      [sport]: filters,
    });
  };

  return {
    filters: playerPageFilters,
    setFilters,
  };
};
